<script setup>
//import Schedule from '@/components/cal/Schedule.vue';
import Schedule from '@/components/common/Event.vue';
import Sim from '@/components/common/ReleaseDate.vue';
import Help from '@/components/help/Help.vue';
</script>
<template>
<div class="calbox">
    <v-sheet height="64">
        <v-toolbar
          flat
        >
          <v-btn
            class="mr-4"
            @click="setToday"
            dark
            style="background-color:#E13533"
          >
           今日 
          </v-btn>
          <v-btn
            class="mr-4"
            @click="simOpen"
            :loading="sim_load"
            dark
            style="background-color:#E13533"
          >
            配信候補日
          </v-btn>

          <v-btn
            fab
            text
            small
            @click="prev"
          >
            <v-icon small>
              mdi-chevron-left
            </v-icon>
          </v-btn>
          <v-btn
            fab
            text
            small
            color="grey darken-2"
            @click="next"
          >
            <v-icon small>
              mdi-chevron-right
            </v-icon>
          </v-btn>
          <v-toolbar-title v-if="$refs.calendar" >
            <a href="javascript:void(0)" v-on:click="type='month'">{{ $refs.calendar.title }}</a>
          </v-toolbar-title>
          <v-spacer></v-spacer>
				<Help />
                  <v-btn
                    class="mr-2"
                    dark
                    icon
                    color="#E13533"
                    to="/config"
                  >
                    <v-icon
                        large
                    >
                    mdi-cog-outline
                    </v-icon>
                  </v-btn>
                <v-icon
                  class="mr-2"
                  dark
                  large
                  color="#E13533"
                  @click="showInput"
                >
                    mdi-pencil
                </v-icon>
          <v-menu
            bottom
            right
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                outlined
                v-bind="attrs"
                v-on="on"
              >
                <span>{{ typeToLabel[type] }}</span>
                <v-icon 
                    small
                right>
                  mdi-menu-down
                </v-icon>
              </v-btn>
            </template>
            <v-list
                dense
            >
              <v-list-item @click="type = 'day'">
                <v-list-item-title>日</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'week'">
                <v-list-item-title>週</v-list-item-title>
              </v-list-item>
              <v-list-item @click="type = 'month'">
                <v-list-item-title>月</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

        </v-toolbar>
      </v-sheet>
      <v-sheet height="600">
        <v-calendar
          ref="calendar"
          v-model="focus"
          color="#E34749"
          :events="events"
          :event-color="getEventColor"
          :type="type"
          @click:event="showEvent"
          @click:more="viewMore"
          @click:date="viewDay"
          @click:time="viewTime"
          @click:day="viewTime"
          @change="updateRange"
          locale="ja-jp"
          :day-format="(timestamp) => new Date(timestamp.date).getDate()"
          :month-format="(timestamp) => (new Date(timestamp.date).getMonth() + 1) + ' /'"
        >
            <template v-slot:day-body="{ date, week }">
                <div
                      class="v-current-time"
                      :class="{ first: date === week[0].date }"
                      :style="{ top: nowY }"
                ></div>
            </template>
        </v-calendar>
        
        <Schedule 
            ref="schdl"
            :dsptype="type"
            :project="project"
            v-on:add-event   ="saveEvent($event)"
            v-on:edit-event ="editEvent($event)"
            v-on:editor-open="editoropen($event)"
            v-on:rel-dl="rel_dl($event)"
        />

      </v-sheet>
    <v-menu
      v-model="showMenu"
      :position-x="x"
      :position-y="y"
      :close-on-content-click="close_on"
      absolute
      offset-y
    >
        <v-toolbar
            height="30px"
            flat
            tile
        >
            <v-spacer>
            </v-spacer>
            <v-btn
                icon
                small
                @click="showMenu=false"
            >
                <v-icon
                    small
                >
                    mdi-close
                </v-icon>
            </v-btn>
        </v-toolbar>
        <v-list
            min-width="200px"
            max-width="200px"
            style="font-size:16px!important"
            class="pt-0"
        >
            <div class="more_title">{{ listtitle }}</div>
            <v-list-item
                  v-for="(item, index) in items"
                  :key="index"
                two-line
                dense
                class="py-0 px-1"
            >
              <v-list-item-content class="py-0 px-1">
                <v-list-item-title>
                    <v-icon
                        small
                        :color="item.color"
                    >
                        mdi-calendar-check
                    </v-icon>
                    {{ item.start }}
                    <a href="javascript:void(0)" v-on:click="viewDetail($event,item.index)">
                        {{ item.title }}
                    </a>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
        </v-list>
    </v-menu>
    <Sim
        ref="sim"
        :relconfirm = "relconfirm"
        :sch_id    = "esch_id"
        v-on:select-release="showRelease($event)"
        v-on:relclose="relclose_status($event)"
        v-on:opened="sim_load=false"
    />
</div>
</template>
<script>

export default{

    props: ["project","selected_cat","selected_pro"],
    data: () => ({
      moment : null,
      focus: '',
      ready: false,
      type: 'month',
      typeToLabel: {
        month: '月',
        week: '週',
        day: '日',
        '4day': '4 Days',
      },
      timeid : null,
      events: [],
      master_cal : [],
      start: null,
      end: null,
      sim_load : false,
      selectedEvent : null,
      close_on : false,
      showMenu : false,
      moreTarg : null,
      edit_flg   : false,
      edit_index : 0,
      listtitle : "",
      relconfirm : false,
      esch_id    : null,
      relevent   : null,
      ch_id: 0,
      x: 0,
      y: 0,
      items: [],
      color: ['#08415C','#42BFDD','#8380B6','#4FB477','#4A2040'],
      category: ['タスク','取材','イベント','プレスリリース','その他'],
    }),
    watch   : {
        type: function(){
            if(this.type!='month')
            {
                this.$nextTick(() => {
                    this.ready = true;
                    this.scrollToTime();
                });
            }
            else
            {
                this.ready = false;
            }
        },
        selected_cat : function(){
              this.events = this.events_update();
        },
        selected_pro : function(){
              this.events = this.events_update();
        },
    },
    computed: {
      cal () {
        return this.ready ? this.$refs.calendar : null;
      },
      nowY () {
        return this.cal ? this.cal.timeToY(this.cal.times.now) + 'px' : '-10px'
      },
    },
    mounted () {
      this.$refs.calendar.checkChange();
    },
    created : function(){
        this.moment = require("moment");
    },
    methods: {
        rel_dl :function(data){
            this.$emit("rel-dl",{doc_id:data.doc_id});
        },
          relclose_status(data){
            this.relconfirm=false;
            if(data.edit)
                this.$emit("editor_open",{release:this.relevent});
            else
                this.relevent = null;
          },
        editoropen : function(data)
        {
            this.$emit("editor_open",{release:data});
        },
      editIndex(){
        var index = 0;
        if(this.selectedEvent == null)
            return index;
        for(index = 0 ; index < this.events.length ; index++)
        {
            if(this.selectedEvent.id==this.events[index].id)
            {
                break;
            }
        }
        return index;
      },
      editEvent(data){
        if(this.selectedEvent && !this.edit_flg)
        {
            if(data.edit_flg==true)
            {
                this.edit_index = this.editIndex();
                this.edit_flg=true;
            }
        }
        else if(!this.edit_flg && this.selectedEvent==null)
        {
            if(data.edit_flg==true)
            {
                this.events.push({
                    name  : "編集中",
                    start : data.start,
                    end   : data.end,
                    color : data.category_color,
                });
                this.edit_index = this.events.length-1;
                this.edit_flg=true;
            }
        }
        if(
        data.edit_flg==false 
        && this.edit_flg==true 
        )
        {
            this.edit_flg=false;
            this.edit_index=0;
            if(this.selectedEvent==null)
                this.events.pop();
            else
                this.events = this.events_update();
        }
        else if(
        data.edit_flg==true
        && this.edit_flg==true 
        )
        {
            this.events[this.edit_index].start=data.start;
            this.events[this.edit_index].end=data.end;
            this.events[this.edit_index].color=data.category_color;
        }
      },
      showRelease(data){
        let moment = require("moment");
        const date = moment(data.date).format("YYYY-MM-DD");
        this.$refs.schdl.showDial({"date":date,"category":"プレスリリース","time":moment(data.date).format("HH:00"),"hasTime":true});
      },
      simOpen(){
        this.sim_load=true;
        this.$refs.sim.simOpen();
      },
      getCurrentTime () {
        return this.cal ? this.cal.times.now.hour * 60 + this.cal.times.now.minute : 0
      },
      scrollToTime () {
        const time = this.getCurrentTime()
        const first = Math.max(0, time - (time % 30) - 30)

        this.cal.scrollToTime(first)
      },
      category_get : function (cat){
        let num = 0;

        for(num = 0 ; num < this.category.length ; num++)
        {
            if(cat == this.category[num])
            {
                break;
            }
        }
        return num;
      },
      saveEvent( data ){
        if(data.save_event!=null && data.save_event.category=="プレスリリース")
        {
            this.relconfirm=true;
            this.relevent = data.save_event;
            this.esch_id = data.save_event.id;
        }
        this.updateSheet (this.start, this.end);
      },
      viewDay ({ date }) {
        this.focus = date
        this.type = 'day'
      },
      viewDetail(event,index) {
        event.preventDefault();
        this.selectedEvent = this.events[index];
        this.$refs.schdl.showEvent (event, this.events[index]);
      },
      viewTime(event,nativeEvent){
        nativeEvent.preventDefault();
        this.showDial(event);
      },
      getEventColor (event) {
        return event.color
      },
      setToday () {
        this.focus = ''
      },
      setDate (date) {
        this.focus =  date;
      },
      prev () {
        this.$refs.calendar.prev()
      },
      next () {
        this.$refs.calendar.next()
      },
      showInput(nativeEvent)
      {
          nativeEvent.preventDefault();
          this.showDial(event);
      },
      showDial(event=null){
        this.selectedEvent = null;
        this.$refs.schdl.showDial(event);
      },
      showEvent ({ nativeEvent, event }) { 
        nativeEvent.preventDefault();
        this.selectedEvent = event;
        this.$refs.schdl.showEvent (nativeEvent , event);
      },
      viewMore( event,nativeEvent ){
        this.moreTarg = nativeEvent;
        nativeEvent.preventDefault();

        this.items = [];
        let moment = require("moment");
        this.listtitle = moment(event.date).format("DD");
        for(var index = 0 ; index < this.events.length ; index++)
        {
            let element = this.events[index];
            let format = "YYYYMMDD";
            let start = moment(element.start).format(format);
            let end   = moment(element.end).format(format);
            let current = moment(event.date).format(format);

            if(start > current || end < current)
            {
                continue;
            }

            if(start <= current && end >= current)
            {
                let starttime = moment(element.start).format("HH:mm");
                this.items.push({title:element.name,start:starttime,index:index,color:element.color});
            }
        }
        this.x = nativeEvent.target.parentElement.getBoundingClientRect().left - 15;
        this.y = nativeEvent.target.parentElement.getBoundingClientRect().top - 30 ;
        const open = () => {
          requestAnimationFrame(() => requestAnimationFrame(() => this.showMenu=true))
        }

        this.$nextTick(() => {
            if (this.showMenu) {
                this.showMenu = false;
                requestAnimationFrame(() => requestAnimationFrame(() => open()));
            } else {
                open();
            }
            nativeEvent.stopPropagation();
        });
      },
      project_list (project){
        if(project === '' || project === null)
        {
            return [];
        }
        var list = [];
        if(typeof(project)!='number')
        {
            list = project.split(",");
        }
        else
        {
            list.push(project);
        }
        var id_list = [];
        for(let i = 0 ;  i < list.length ; i++)
            id_list.push(Number(list[i]));
        return id_list;
      },
      events_update(){
        const events = [];
        for(let i = 0; i < this.master_cal.length ; i++)
        {
            if
            (
            this.master_cal[i].timed == 't' 
            || this.master_cal[i].timed==true
            )
            {
                this.master_cal[i].timed = true;
            }
            else
            {
                this.master_cal[i].timed = false;
            }

            var show_flg=false;
            for(let ci = 0 ; ci < this.selected_cat.length ; ci++)
            {
                if(this.master_cal[i].category == '')
                {
                    this.master_cal[i].category = 'その他';
                }
                if(this.selected_cat[ci]==this.master_cal[i].category)
                {
                    show_flg = true;
                    break;
                }
            }
            if(!show_flg)
                continue;
            else
                show_flg=false;

            let pro_list = this.project_list(this.master_cal[i].project);

            for(let ci = 0 ; ci < this.selected_pro.length ; ci++)
            {
                for(let vi = 0 ; vi < pro_list.length ; vi++)
                {
                    if(pro_list[vi]==this.selected_pro[ci])
                    {
                        show_flg = true;
                        break;
                    }
                }
            }
            if(!show_flg && this.master_cal[i].project != null)
                continue;
            else
                show_flg=false;

            events.push({
              name: this.master_cal[i].name,
              start: new Date(this.master_cal[i].start),
              end: new Date(this.master_cal[i].end),
              color: this.color[this.category_get(this.master_cal[i].category)],
              category : this.master_cal[i].category,
              timed: this.master_cal[i].timed,
              id: this.master_cal[i].id,
              summary: this.master_cal[i].summary,
              place: this.master_cal[i].place,
              project : pro_list,
              doc_id  : this.master_cal[i].doc_id,
              rel_title  : this.master_cal[i].rel_title,
              index : i,
            });
        }
        return events;
      },
      async updateSheet (start, end){
        var params = new URLSearchParams();
        params.append('start', start);
        params.append('end', end);
        let axios = require('axios');
        await axios.post("https://qlipper.jp/api/events/get_cal.php",params,{withCredentials: true,})
        .then(response => {
            this.master_cal = response.data;
        });
        this.events = this.events_update();

      },
      updateRange ({ start, end }) {

        let moment = require("moment");
        const start_day=moment(start.date).day();
        const end_day=moment(end.date).day();

        this.start = start.date;
        this.end = end.date;

        //let start_adjust = Number(start_day) * Number(-1);
        let end_adjust   = 6 -Number(end_day);


        if(this.type=="month")
        {
            if(start_day != 0)
                this.start = moment(this.start).add((start_day*-1),'days').format("YYYY-MM-DD");
            if(end_day != 6)
                this.end   = moment(this.end).add(end_adjust,'days').format("YYYY-MM-DD");
        }

        this.edit_flg=false;
        this.updateSheet (this.start, this.end);
        this.$nextTick(() => {
            let elem = null;
            if(this.type=="month")
            {
                elem = document.querySelector(".v-calendar-weekly__day.v-present button");
            }
            else
            {
                elem = document.querySelector(".v-calendar-daily_head-day.v-present button");
            }
            if(elem != null)
            {
                elem.style.color="white";
            }
        });
      },
    },
  }
</script>
<style>
.v-current-time {
  height: 2px;
  background-color: #ea4335;
  position: absolute;
  left: -1px;
  right: 0;
  pointer-events: none;
}
.v-current-time.first::before {
  content: "";
  position: absolute;
  background-color: #ea4335;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-top: -5px;
  margin-left: -6.5px;
}

.more_title{
    display: block;
    width: 100%;
    text-align: center;
    font-size: 2rem;
    font-weight: 600;
}
</style>
